export const ORDERS_ROUTES = {
  ROOT: "orders",
  CREATE: "create",
  DETAIL: ":orderId",
};
